// React
import React from 'react';

// Blockly
import 'blockly/blocks';

// VMT Blockly
import { Category, Block, Value, Shadow, Field, Next, Sep, Label, Statement } from 'components/BlocklyComponent';

import { Colors } from 'utils/const';

export const ToolBox = (
    <>
        <Category name="Bricks" colour="210"></Category>
        <Category name="Variables" categorystyle="variable_category" custom="VMT_VARIABLE"></Category>
        <Sep></Sep>
        {/* <Category name="Advanced" expanded="true" > */}
        <Category name="Actions" colour={Colors.ACTION_INPUT_COLOR}>
            <Label text="Actions" web-class="ioLabel"></Label>
            {/* <Block type="action_value_to_statement"></Block> */}
            <Block type="action_text">
                <Value name="TEXT">
                    <Shadow type="text">
                        <Field name="TEXT">text</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="action_text_stack">
                <Value name="TEXT">
                    <Shadow type="text">
                        <Field name="TEXT">text</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="action_type"></Block>
            <Block type="action_stack"></Block>
            <Block type="action_constrained_stack">
                <Value name="CONSTRAINT">
                    <Shadow type="math_number">
                        <Field name="NUM">0</Field>
                    </Shadow>
                </Value>
                <Next>
                    <Block type="action_stack"></Block>
                </Next>
            </Block>
            <Block type="action_constrained_stack">
                <Value name="CONSTRAINT">
                    <Shadow type="math_number">
                        <Field name="NUM">0</Field>
                    </Shadow>
                </Value>
                <Next>
                    <Block type="action_text_stack">
                        <Value name="TEXT">
                            <Shadow type="text">
                                <Field name="TEXT">text</Field>
                            </Shadow>
                        </Value>
                    </Block>
                </Next>
            </Block>
            <Label text="Getters" web-class="ioLabel"></Label>
            <Block type="attr_getter"></Block>
            <Block type="attr_getter_stack"></Block>
            <Label text="Grouping" web-class="ioLabel"></Label>
            <Block type="vmt_group"></Block>
            {/* <Block type="action_value_to_statement" disabled="true"></Block> */}
        </Category>
        <Category name="Validators" colour={Colors.ACTION_VERIFY_COLOR}>
            <Label text="Expect Actions" web-class="ioLabel"></Label>
            <Block type="expect_action"></Block>
            <Block type="expect_action_stack"></Block>
            {/* <Block type="is_validator">
                <Value name="EXPECTED_VALUE">
                    <Shadow type="logic_boolean">
                        <Field name="BOOL">TRUE</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="is_validator_stack">
                <Value name="EXPECTED_VALUE">
                    <Shadow type="logic_boolean">
                        <Field name="BOOL">TRUE</Field>
                    </Shadow>
                </Value>
            </Block> */}
            <Label text="Evaluate Bricks" web-class="ioLabel"></Label>
            <Block type="evaluate_brick">
                <Value name="EXPECTED_VALUE">
                    <Shadow type="text">
                        <Field name="TEXT">text</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="vmt_group">
                <Statement name="GROUP_STATEMENT">
                    <Block type="evaluate_brick">
                        <Value name="EXPECTED_VALUE">
                            <Shadow type="text">
                                <Field name="TEXT">text</Field>
                            </Shadow>
                        </Value>
                    </Block>
                </Statement>
            </Block>
        </Category>
        <Category name="Browser Actions" colour="330">
            <Block type="browser_commands">
                <Value name="VALUE">
                    <Shadow type="text">
                        <Field name="TEXT">https://</Field>
                    </Shadow>
                </Value>
            </Block>
        </Category>
        <Category name="Reusable" colour={Colors.ACTION_BROWSER_COLOR}>
            <Block type="vmt_reusable_brick_init" />
            <Block type="vmt_reusable_brick_init_statement">
                {/* <Value name="TOP">
                    <Shadow type="vmt_param_drop" />
                </Value> */}
            </Block>
            <Block type="vmt_parameter" />
        </Category>
        <Sep></Sep>
        <Category name="Logic" categorystyle="logic_category">
            <Block type="if_statement"></Block>
            <Block type="logic_boolean"></Block>
            <Block type="logic_negate"></Block>
            <Label text="IF statement variations" web-class="ioLabel"></Label>
            <Block type="if_statement">
                <Statement name="IF0">
                    <Block type="evaluate_brick">
                        <Value name="EXPECTED_VALUE">
                            <Shadow type="text">
                                <Field name="TEXT">text</Field>
                            </Shadow>
                        </Value>
                    </Block>
                </Statement>
            </Block>
            <Block type="if_statement">
                <Statement name="IF0">
                    <Block type="evaluate_brick">
                        <Value name="EXPECTED_VALUE">
                            <Shadow type="math_number">
                                <Field name="NUM">0</Field>
                            </Shadow>
                        </Value>
                    </Block>
                </Statement>
            </Block>
            {/* <Block type="controls_if">
                <Value name="IF0">
                    <Block type="logic_compare">
                        <Value name="B">
                            <Shadow type="text">
                                <Field name="TEXT"></Field>
                            </Shadow>
                        </Value>
                    </Block>
                </Value>
            </Block>
            <Block type="controls_if">
                <Value name="IF0">
                    <Block type="logic_compare">
                        <Value name="B">
                            <Shadow type="math_number">
                                <Field name="NUM">0</Field>
                            </Shadow>
                        </Value>
                    </Block>
                </Value>
            </Block>
            <Block type="controls_if"></Block> */}
            {/* <Block type="logic_compare"></Block> */}
            {/* <Block type="logic_operation"></Block>
                <Block type="logic_boolean"></Block>
                <Block type="logic_null"></Block>
                <Block type="logic_ternary"></Block> */}
        </Category>
        <Category name="Loops" categorystyle="loop_category">
            <Block type="controls_repeat_ext">
                <Value name="TIMES">
                    <Shadow type="math_number">
                        <Field name="NUM">10</Field>
                    </Shadow>
                </Value>
            </Block>
            {/* <Block type="controls_whileUntil"  disabled="true"></Block>
                <Block type="controls_for">
                    <Value name="FROM">
                        <Shadow type="math_number">
                            <Field name="NUM">1</Field>
                        </Shadow>
                    </Value>
                    <Value name="TO">
                        <Shadow type="math_number">
                            <Field name="NUM">10</Field>
                        </Shadow>
                    </Value>
                    <Value name="BY">
                        <Shadow type="math_number">
                            <Field name="NUM">1</Field>
                        </Shadow>
                    </Value>
                </Block>
                <Block type="controls_forEach" disabled="true"></Block>
                <Block type="controls_flow_statements"></Block> */}
        </Category>
        <Category name="Math" categorystyle="math_category">
            <Block type="math_number" gap="32"></Block>
            <Block type="math_arithmetic">
                <Value name="A">
                    <Shadow type="math_number">
                        <Field name="NUM">1</Field>
                    </Shadow>
                </Value>
                <Value name="B">
                    <Shadow type="math_number">
                        <Field name="NUM">1</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="math_single">
                <Value name="NUM">
                    <Shadow type="math_number">
                        <Field name="NUM">9</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="math_number_property">
                <Value name="NUMBER_TO_CHECK">
                    <Shadow type="math_number">
                        <Field name="NUM">0</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="math_round">
                <Value name="NUM">
                    <Shadow type="math_number">
                        <Field name="NUM">3.1</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="math_random_int">
                <Value name="FROM">
                    <Shadow type="math_number">
                        <Field name="NUM">1</Field>
                    </Shadow>
                </Value>
                <Value name="TO">
                    <Shadow type="math_number">
                        <Field name="NUM">100</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="math_random_float"></Block>
        </Category>
        <Category name="Text" categorystyle="text_category">
            <Block type="text"></Block>
            {/* <Block type="text_join"></Block> */}
            <Block type="text_concat">
                <Value name="TEXT_A">
                    <Shadow type="text"></Shadow>
                </Value>
                <Value name="TEXT_B">
                    <Shadow type="text"></Shadow>
                </Value>
            </Block>
            {/* <Block type="text_multiline"></Block> */}
            <Block type="text_isEmpty">
                <Value name="VALUE">
                    <Shadow type="text">
                        <Field name="TEXT"></Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="text_append">
                <Value name="TEXT">
                    <Shadow type="text"></Shadow>
                </Value>
            </Block>
            <Block type="text_length">
                <Value name="VALUE">
                    <Shadow type="text">
                        <Field name="TEXT">abc</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="text_indexOf">
                <Value name="VALUE">
                    <Block type="vmt_variables_get">
                        <Field name="VAR">text</Field>
                    </Block>
                </Value>
                <Value name="FIND">
                    <Shadow type="text">
                        <Field name="TEXT">abc</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="text_charAt">
                <Value name="VALUE">
                    <Block type="vmt_variables_get">
                        <Field name="VAR">text</Field>
                    </Block>
                </Value>
            </Block>
            <Block type="text_getSubstring">
                <Value name="STRING">
                    <Block type="vmt_variables_get">
                        <Field name="VAR">text</Field>
                    </Block>
                </Value>
            </Block>
            <Block type="text_changeCase">
                <Value name="TEXT">
                    <Shadow type="text">
                        <Field name="TEXT">abc</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="text_trim">
                <Value name="TEXT">
                    <Shadow type="text">
                        <Field name="TEXT">abc</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="text_count">
                <Value name="SUB">
                    <Shadow type="text"></Shadow>
                </Value>
                <Value name="TEXT">
                    <Shadow type="text"></Shadow>
                </Value>
            </Block>
            <Block type="text_replace">
                <Value name="FROM">
                    <Shadow type="text"></Shadow>
                </Value>
                <Value name="TO">
                    <Shadow type="text"></Shadow>
                </Value>
                <Value name="TEXT">
                    <Shadow type="text"></Shadow>
                </Value>
            </Block>
            <Block type="text_reverse">
                <Value name="TEXT">
                    <Shadow type="text"></Shadow>
                </Value>
            </Block>
            <Label text="Input/Output:" web-class="ioLabel"></Label>
            <Block type="text_print">
                <Value name="TEXT">
                    <Shadow type="text">
                        <Field name="TEXT">abc</Field>
                    </Shadow>
                </Value>
            </Block>
            <Block type="text_prompt_ext">
                <Value name="TEXT">
                    <Shadow type="text">
                        <Field name="TEXT">abc</Field>
                    </Shadow>
                </Value>
            </Block>
        </Category>
        <Sep></Sep>
    </>
);

export const ToolBoxJSON = {
    "kind": "categoryToolbox",
    "contents": [
        {
            "kind": "category",
            "name": "Bricks",
            "colour": "210",
            "contents": [],
        },
        {
            "kind": "category",
            "name": "Variables",
            "categorystyle": "variable_category",
            "custom": "VMT_VARIABLE"
        },
        {
            "kind": "category",
            "name": "Local Reusable Blocks",
            "categorystyle": "variable_category",
            "custom": "VMT_REUSABLE_BLOCK"
        },
        {
            "kind": "sep",
            // "cssConfig": {
            //   "container": "yourClassName"
            // }
        },
        {
            "kind": "category",
            "name": "Actions",
            "colour": Colors.ACTION_INPUT_COLOR,
            "contents": [
                {
                    "kind": "label",
                    "text": "Actions",
                    "web-class": "ioLabel"
                },
                {
                    "kind": "block",
                    "type": "action_text",
                    "inputs": {
                        "TEXT": {
                            "shadow": {
                                "type": "text",
                                "fields": {
                                    "TEXT": "text"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "block",
                    "type": "action_text_stack",
                    "inputs": {
                        "TEXT": {
                            "shadow": {
                                "type": "text",
                                "fields": {
                                    "TEXT": "text"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "block",
                    "type": "action_type"
                },
                {
                    "kind": "block",
                    "type": "action_type"
                },
                {
                    "kind": "block",
                    "type": "action_constrained_stack",
                    "inputs": {
                        "CONSTRAINT": {
                            "shadow": {
                                "type": "math_number",
                                "fields": {
                                    "NUM": 0
                                }
                            }
                        },
                    },
                    "next": {
                        "block": {
                            "type": "action_stack"
                        }
                    }
                },
                {
                    "kind": "block",
                    "type": "action_constrained_stack",
                    "inputs": {
                        "CONSTRAINT": {
                            "shadow": {
                                "type": "math_number",
                                "fields": {
                                    "NUM": 0
                                }
                            }
                        },
                    },
                    "next": {
                        "block": {
                            "type": "action_text_stack",
                            "inputs": {
                                "TEXT": {
                                    "shadow": {
                                        "type": "text",
                                        "fields": {
                                            "TEXT": "text"
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "label",
                    "text": "Getters",
                    "web-class": "ioLabel"
                },
                {
                    "kind": "block",
                    "type": "attr_getter"
                },
                {
                    "kind": "block",
                    "type": "attr_getter_stack"
                },
                {
                    "kind": "label",
                    "text": "Grouping",
                    "web-class": "ioLabel"
                },
                {
                    "kind": "block",
                    "type": "vmt_group"
                },

            ]
        },
        {
            "kind": "category",
            "name": "Validators",
            "colour": Colors.ACTION_VERIFY_COLOR,
            "contents": [
                {
                    "kind": "label",
                    "text": "Expect Actions",
                    "web-class": "ioLabel"
                },
                {
                    "kind": "block",
                    "type": "expect_action"
                },
                {
                    "kind": "block",
                    "type": "expect_action_stack"
                },
                {
                    "kind": "label",
                    "text": "Evaluate Bricks",
                    "web-class": "ioLabel"
                },
                {
                    "kind": "block",
                    "type": "evaluate_brick",
                    "inputs": {
                        "EXPECTED_VALUE": {
                            "shadow": {
                                "type": "text",
                                "fields": {
                                    "TEXT": "text"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "block",
                    "type": "vmt_group",
                    "inputs": {
                        "GROUP_STATEMENT": {
                            "block": {
                                "type": "evaluate_brick",
                                "inputs": {
                                    "EXPECTED_VALUE": {
                                        "shadow": {
                                            "type": "text",
                                            "fields": {
                                                "TEXT": "text"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "block",
                    "type": "logic_boolean"
                },
            ],
        },
        {
            "kind": "category",
            "name": "Browser Actions",
            "colour": "330",
            "contents": [
                {
                    "kind": "block",
                    "type": "browser_commands",
                    "inputs": {
                        "VALUE": {
                            "shadow": {
                                "type": "text",
                                "fields": {
                                    "TEXT": "https://"
                                }
                            }
                        }
                    }
                }
            ],
        },
        {
            "kind": "category",
            "name": "Reusable",
            "colour": Colors.ACTION_BROWSER_COLOR,
            "contents": [
                {
                    "kind": "block",
                    "type": "vmt_reusable_brick_init"
                },
                {
                    "kind": "block",
                    "type": "vmt_reusable_brick_init_statement"
                },
                {
                    "kind": "block",
                    "type": "vmt_parameter"
                }
            ]
        },
        {
            "kind": "sep"
        },
        {
            "kind": "category",
            "name": "Logic",
            "categorystyle": "logic_category",
            "contents": [
                {
                    "kind": "block",
                    "type": "if_statement"
                },
                {
                    "kind": "block",
                    "type": "logic_boolean"
                },
                {
                    "kind": "block",
                    "type": "logic_negate"
                },
                {
                    kind: 'label',
                    text: 'IF statement variations',
                    webClass: 'ioLabel'
                },
                {
                    "kind": "block",
                    "type": "if_statement",
                    "inputs": {
                        "IF0": {
                            "block": {
                                "type": "evaluate_brick",
                                "inputs": {
                                    "EXPECTED_VALUE": {
                                        "shadow": {
                                            "type": "text",
                                            "fields": {
                                                "TEXT": "text"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "block",
                    "type": "if_statement",
                    "inputs": {
                        "IF0": {
                            "block": {
                                "type": "evaluate_brick",
                                "inputs": {
                                    "EXPECTED_VALUE": {
                                        "shadow": {
                                            "type": "math_number",
                                            "fields": {
                                                "NUM": 0
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
            ]
        },
        {
            "kind": "category",
            "name": "Loops",
            "categorystyle": "loop_category",
            "contents": [
                {
                    "kind": "block",
                    "type": "controls_repeat_ext",
                    "inputs": {
                        "TIMES": {
                            "shadow": {
                                "type": "math_number",
                                "fields": {
                                    "NUM": 10
                                }
                            }
                        }
                    }
                },
            ]
        },
        {
            "kind": "category",
            "name": "Math",
            "categorystyle": "math_category",
            "contents": [
                {
                    kind: 'block',
                    type: 'math_number',
                    gap: 32
                },
                {
                    kind: 'block',
                    type: 'math_arithmetic',
                    inputs: {
                        A: {
                            shadow: {
                                type: 'math_number',
                                fields: { NUM: 1 }
                            }
                        },
                        B: {
                            shadow: {
                                type: 'math_number',
                                fields: { NUM: 1 }
                            }
                        }
                    }
                },
                {
                    kind: 'block',
                    type: 'math_single',
                    inputs: {
                        NUM: {
                            shadow: {
                                type: 'math_number',
                                fields: { NUM: 9 }
                            }
                        }
                    }
                },
                {
                    kind: 'block',
                    type: 'math_number_property',
                    inputs: {
                        NUMBER_TO_CHECK: {
                            shadow: {
                                type: 'math_number',
                                fields: { NUM: 0 }
                            }
                        }
                    }
                },
                {
                    kind: 'block',
                    type: 'math_round',
                    inputs: {
                        NUM: {
                            shadow: {
                                type: 'math_number',
                                fields: { NUM: 3.1 }
                            }
                        }
                    }
                },
                {
                    kind: 'block',
                    type: 'math_random_int',
                    inputs:
                    {
                        FROM:
                        {
                            shadow:
                                { type: 'math_number', fields: { NUM: 1 } }
                        },
                        TO:
                        {
                            shadow:
                                { type: 'math_number', fields: { NUM: 100 } }
                        }
                    }
                },
                { kind: 'block', type: 'math_random_float' }

            ]
        },
        {
            "kind": "category",
            "name": "Text",
            "categorystyle": "text_category",
            "contents": [
                {
                    kind: 'block',
                    type: 'text'
                },
                {
                    kind: 'block',
                    type: 'text_concat',
                    inputs: {
                        TEXT_A: {
                            shadow: {
                                type: 'text'
                            }
                        },
                        TEXT_B: {
                            shadow: {
                                type: 'text'
                            }
                        }
                    }
                },
                {
                    kind: 'block',
                    type: 'text_isEmpty',
                    inputs: {
                        VALUE: {
                            shadow: {
                                type: 'text',
                                fields: { TEXT: '' }
                            }
                        }
                    }
                },
                {
                    kind: 'block',
                    type: 'text_append',
                    inputs: {
                        TEXT: {
                            shadow: {
                                type: 'text'
                            }
                        }
                    }
                },
                {
                    kind: 'block',
                    type: 'text_length',
                    inputs: {
                        VALUE: {
                            shadow: {
                                type: 'text',
                                fields:
                                    { TEXT: 'abc' }
                            }
                        }
                    }
                },
                {
                    kind: 'block',
                    type: 'text_indexOf',
                    inputs: {
                        VALUE: {
                            block: {
                                type: 'vmt_variables_get',
                                fields: { VAR: 'text' }
                            }
                        },
                        FIND: {
                            shadow: {
                                type: 'text', fields: { TEXT: 'abc' }
                            }
                        }
                    }
                },
                { kind: 'block', type: 'text_charAt', inputs: { VALUE: { block: { type: 'vmt_variables_get', fields: { VAR: 'text' } } } } },
                { kind: 'block', type: 'text_getSubstring', inputs: { STRING: { block: { type: 'vmt_variables_get', fields: { VAR: 'text' } } } } },
                { kind: 'block', type: 'text_changeCase', inputs: { TEXT: { shadow: { type: 'text', fields: { TEXT: 'abc' } } } } },
                { kind: 'block', type: 'text_trim', inputs: { TEXT: { shadow: { type: 'text', fields: { TEXT: 'abc' } } } } },
                { kind: 'block', type: 'text_count', inputs: { SUB: { shadow: { type: 'text' }, }, TEXT: { shadow: { type: 'text' }, }, } },
                {
                    kind: 'block',
                    type: 'text_replace',
                    inputs: {
                        FROM: { shadow: { type: 'text' }, },
                        TO: { shadow: { type: 'text' }, },
                        TEXT: { shadow: { type: 'text' }, }
                    }
                },
                { kind: 'block', type: 'text_reverse', inputs: { TEXT: { shadow: { type: 'text' } } } },
                {
                    kind: 'label',
                    text: 'Input/Output:',
                    webClass: 'ioLabel'
                },
                {
                    kind: 'block',
                    type: 'text_print',
                    inputs: {
                        TEXT: {
                            shadow: {
                                type: 'text',
                                fields: { TEXT: 'abc' }
                            }
                        }
                    }
                },
                {
                    kind: 'block',
                    type: 'text_prompt_ext',
                    inputs: {
                        TEXT: {
                            shadow: {
                                type: 'text',
                                fields: { TEXT: 'abc' }
                            }
                        }
                    }
                },
            ]
        },
        {
            "kind": "sep"
        }
    ]
};
